module.exports = __webpack_public_path__ + "img/check-green.363b9b72.svg";